import React from "react";
import siteConfig from "../../../config";

const images = {
  Login: "/assets/images/login.png",
  SignUp: "/assets/images/signUp.png",
  Register: "/assets/images/register.png",
  ForgotPassword: "/assets/images/forgotPassword.png",
  ResetPassword: "/assets/images/resetPassword.png",
  Otp: "/assets/images/otp.png",
  Authentication: "/assets/images/authentication.png",
};

const AuthLayout = ({ children, title }) => {
  const imageSrc = images[title];
  return (
    <>
      <div className="min-h-screen grid lg:grid-cols-2 grid-cols-1 lg:bg-[#F4F4F4]">
        <div className="xl:ps-10 xl:py-8 lg:ps-8 lg:py-10">
          <div className="h-full grid justify-items-center content-center bg-white rounded-lg lg:relative pt-2">
            <div className="lg:absolute lg:left-4 lg:top-4 lg:mb-0 mb-2">
              {siteConfig?.authLogo || siteConfig?.logo ? (
                <img
                  src={siteConfig?.authLogo || siteConfig?.logo}
                  alt="logo"
                  className={`${
                    siteConfig?.authLogo ? "h-[125px]" : "h-[44px]"
                  }  w-full object-contain`}
                />
              ) : (
                <h2 className="font-bold text-4xl uppercase lg:mb-0 mb-10">
                  {siteConfig.name}
                </h2>
              )}
            </div>
            <div className="w-full flex justify-center items-center md:px-0 px-3 mt-6">
              {children}
            </div>
          </div>
        </div>
        <div className="h-full grid justify-items-center content-center lg:mt-0 sm:mt-7 ">
          <img
            src={imageSrc}
            alt="image not found"
            className="object-cover w-4/5"
          />
        </div>
      </div>
    </>
  );
};
export default AuthLayout;
